import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Text } from 'recharts';

// BarChartComponent receives 'data' as a prop

const CustomXAxisTick = ({ x, y, payload }) => {
    if (payload && payload.value) {
      return (
        <Text
            fontSize={"12px"}
            width={"12px"}
            x={x}
            y={y}
            textAnchor="middle"
            verticalAnchor="start"
        >{payload.value}</Text>
      );
    }
    return null;
};

const BarChartComponent = ({ data }) => {
  return (
   <BarChart
  width={400}
  height={200}
  data={data}
  margin={{
    top: 5, right: 30, left: 20, bottom: 50,
  }}
  barSize={20}
>
  <XAxis
    dataKey="name"
    padding={{ left: 10, right: 10 }}
    interval={0}
    wrapStyle={{ lineHeight: 1.5 }}
    maxWidth={100}
    tick={<CustomXAxisTick/>}
  />
  <YAxis  type="number" domain={[0, 10]} />
  <Tooltip />
  <CartesianGrid strokeDasharray="3 3" />
  <Bar dataKey="value" fill="#8884d8" background={{ fill: '#eee' }} />
</BarChart>
  );
}

export default BarChartComponent;